export const avatarImageStyles = {
  width: 120,
  height: 120,
  borderRadius: "50%",
  boxShadow: 3,
  objectFit: "cover",
};

// export const userAvatarStyles = {
//   boxShadow: 3,
// };
